import type { SoftwareDto } from '@bk/contracts';
import { useState } from 'react';
import { navigate } from '../../lib/router';
import { useTenant, useTenantQuery } from '../../lib/useTenant';
import { Card, Empty, ErrorText, PageTitle } from '../../ui';
import { errorMessage } from '../../lib/api';
import { MailboxForm } from './Mailboxes';
import { ConnectForm } from './Software';

/**
 * Pagina aperta dal link che l'assistente AI dà all'utente per collegare un programma o una casella: le credenziali
 * si scrivono qui, dopo il login, e non passano mai dalla chat.
 */
export function ConnectPage({ kind, target }: { kind?: string; target?: string }) {
  const { tenant } = useTenant();
  const [done, setDone] = useState(false);
  const software = useTenantQuery<{ data: SoftwareDto[] }>(['software'], '/software', { enabled: kind === 'programma' });
  const s = software.data?.data.find((x) => x.id === target);
  const back = () => navigate(`/t/${tenant.id}/collega/fatto`);

  if (kind === 'fatto' || done)
    return (
      <div className="mx-auto max-w-xl">
        <PageTitle title="Fatto" subtitle="Torna alla chat con il tuo assistente: vedrà il collegamento e proseguirà da lì." />
      </div>
    );
  return (
    <div className="mx-auto max-w-xl">
      <PageTitle
        title={kind === 'casella' ? 'Collega una casella di posta' : `Collega ${s?.name ?? 'un programma'}`}
        subtitle="Le credenziali si inseriscono solo qui: restano cifrate e non passano mai dalla chat con l’assistente."
      />
      <Card>
        {kind === 'programma' && (
          <>
            <ErrorText>{software.error ? errorMessage(software.error) : ''}</ErrorText>
            {software.data && !s && <Empty>Programma non trovato in questa azienda.</Empty>}
            {s && (s.assessment?.connection_fields.length || s.assessment?.oauth ? <ConnectForm s={s} onDone={() => setDone(true)} /> : <Empty>Per {s.name} non c’è ancora un modo per collegarlo: chiedi all’assistente di valutarlo di nuovo.</Empty>)}
          </>
        )}
        {kind === 'casella' && <MailboxForm initialAddress={target ? decodeURIComponent(target) : ''} onDone={() => setDone(true)} onCancel={back} />}
        {kind !== 'programma' && kind !== 'casella' && <Empty>Link non valido.</Empty>}
      </Card>
    </div>
  );
}
